import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function Dotnav({ setCategoryLevel, categoryLevel, user }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentRoute, setCurrentRoute] = useState(location.pathname);
  const routes = ['/publishers', '/categories', '/formats', '/supplytype'];

  useEffect(() => {
    setCurrentRoute(location.pathname);
  }, [location.pathname]);

  const goToPreviousRoute = () => {
    const currentIndex = routes.indexOf(currentRoute);
    if (currentIndex > 0) {
      if (user.role && currentRoute === '/categories' && categoryLevel === 'Sub') {
        setCategoryLevel('Top'); // Update categoryLevel when moving from 'Sub' to 'Top'
      } else {
        navigate(routes[currentIndex - 1]);
      }
    }
  };

  const goToNextRoute = () => {
    const currentIndex = routes.indexOf(currentRoute);
    if (currentIndex < routes.length - 1) {
      if (user.role && currentRoute === '/categories' && categoryLevel === 'Top') {
        setCategoryLevel('Sub'); // Update categoryLevel when moving from 'Top' to 'Sub'
      } else {
        navigate(routes[currentIndex + 1]);
      }
    }
  };

  const isFirstRoute = routes.indexOf(currentRoute) === 0;
  const isLastRoute = routes.indexOf(currentRoute) === routes.length - 1;

  return (
    <div className="dot-nav">
      <button
        className={`dotbutton ${isFirstRoute ? 'primary' : ''}`}
        onClick={goToPreviousRoute}
      >
        Back
      </button>
      {routes.slice(0, 2).map((route, index) => (
        <div
          key={index}
          className={`dot ${currentRoute === route && categoryLevel === 'Top' ? 'active' : ''}`}
        ></div>
      ))}
      {user.role && (
        <div
          className={`dot extra-dot ${currentRoute === '/categories' && categoryLevel === 'Sub' ? 'active' : ''}`}
        ></div>
      )}
      {routes.slice(2).map((route, index) => (
        <div
          key={index + 2} // Add 2 to the index to avoid conflicting keys
          className={`dot ${currentRoute === route ? 'active' : ''}`}
        ></div>
      ))}
      <button
        className={`dotbutton ${isLastRoute ? 'primary' : ''}`}
        onClick={goToNextRoute}
      >
        Next
      </button>
    </div>
  );
}

export default Dotnav;
